export const getIsReplaying = (state) => state.interactions.isReplayingInteractions || state.interactions.isReplayingAuth || state.interactions.isReplayingFullSequence
